const envEndpoints = {
  loginWidgetESM: process.env.REACT_APP_LOGIN_WIDGET_ESM,
  loginWidget: process.env.REACT_APP_LOGIN_WIDGET,
  loginRedirect: process.env.REACT_APP_LOGIN_REDIRECT,
  baseApiUrl: process.env.REACT_APP_BASE_API_URL,
  baseContentUrl: process.env.REACT_APP_BASE_CONTENT_URL,
  appInsightsKey: process.env.REACT_APP_INSIGHT_KEY,
  scope: process.env.REACT_APP_SCOPE,
  clientID: process.env.REACT_APP_CLIENT_ID,
  ls_name: process.env.REACT_APP_LS_NAME,
  paypalClientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
  spxPurchaseUrl: process.env.REACT_APP_SPX_PURCHASE_URL,
  pdfViewerWorkerSrc: process.env.REACT_APP_PDFVIEWER_WORKER_SRC,
  pmbok7TocUrl: process.env.REACT_APP_PMBOK7_TOC_URL,
  showBanner: process.env.REACT_APP_SHOW_BANNER,
  memberBannerMessage: process.env.REACT_APP_MEMBER_BANNER_MESSAGE,
  nonMemberBannerMessage: process.env.REACT_APP_NON_MEMBER_BANNER_MESSAGE,
  adobeLegacySrcURL: process.env.REACT_APP_ADOBE_ANALYTICS_LEGACY_SCRIPT,
  adobeDataLayerURL: process.env.REACT_APP_ADOBE_DATA_LAYER_SCRIPT,
  adobeSrcURL: process.env.REACT_APP_ADOBE_ANALYTICS_SCRIPT,
  adobeEventListenerURL: process.env.REACT_APP_ADOBE_EVENT_LISTENER_SCRIPT,
  legacyAdobeEnabled: process.env.REACT_APP_LEGACY_ADOBE_SCRIPT_SRC_ENABLED,
  newTocEnabled: process.env.REACT_APP_NEW_TOC_ENABLED
};

const getEnvEndpoints = () => {
  return envEndpoints;
}

export default getEnvEndpoints;
